<template>
  <main class="main">
    <div>
      <h1>Вы ещё не привели ни одного клиента :&nbsp;(</h1>
    </div>
    <div v-if="isHasInfo" class="user__container container">
      <div class="btn-wrapper">
        <button :class="{ 'btn-active': activeContentId === 1  }" class="content__button btn-reset" @click.prevent="changeContent(1)">
          Данные о пользователе
        </button>
        <button :class="{ 'btn-active': activeContentId === 2  }" class="content__button btn-reset" @click.prevent="changeContent(2)">
          Лиды
        </button>
      </div>
      <div class="content__container">
        <ul v-if="activeContentId === 1" class="data__list list-reset">
          <li class="data__item">
            Дата регистрации: 25.02.2022
          </li>
          <li class="data__item">
            Количество лидов: 8
          </li>
          <li class="data__item">
            Количество договоров: 1
          </li>
          <li class="data__item">
            Общий доход от лидов (RUB): 250 000
          </li>
        </ul>
        <table v-else-if="activeContentId === 2">
          <thead>
            <tr>
              <th>Дата обращения лида</th>
              <th>Название лида</th>
              <th>Статус лида</th>
              <th>Дата договора</th>
              <th>Наименование вакансий в работе</th>
              <th>Ориентировочный доход по вакансии</th>
              <th>Статус вакансии</th>
              <th>Дата оплаты</th>
              <th>Сумма оплаты</th>
              <th>Валюта оплаты</th>
              <th>Личный доход</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>22.03.2022</td>
              <td>QSoft</td>
              <td>В работе</td>
              <td>28.03.2022</td>
              <td>QSoft, веб-разработчик (Laravel)</td>
              <td>30 000</td>
              <td>В работе</td>
              <td>&mdash;</td>
              <td>300 000</td>
              <td>RUB</td>
              <td>30 000</td>
            </tr>
            <tr>
              <td>22.03.2022</td>
              <td>QSoft</td>
              <td>В работе</td>
              <td>28.03.2022</td>
              <td>QSoft, веб-разработчик (Laravel)</td>
              <td>30 000</td>
              <td>В работе</td>
              <td>&mdash;</td>
              <td>300 000</td>
              <td>RUB</td>
              <td>30 000</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </main>
</template>

<style scoped>
h1 {
  line-height: 120%;
  text-align: center;
}

.main {
  padding-top: 100px;
  padding-bottom: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
  font-size: 16px;
  background-color: #fff;
}

.content__button {
  padding: 12px 3px;
  width: 160px;
  font-size: 12px;
  line-height: 14px;
  color: black;
}

.content__button.btn-active {
  border: 1px solid #CACACA;
  border-bottom: none;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.content__container {
  position: relative;
  padding-top: 10px;
  border-top: 1px solid #CACACA;;
  overflow-x: auto;
}

.data__item:not(:last-child) {
  margin-bottom: 20px;
}

table {
  border-spacing: 0;
  min-width: 1100px;
}

th {
  margin: 0;
  border-bottom: 1px solid #000;
}

tbody {
  padding-top: 20px;
}

td, th {
  padding: 7px 3px;
  font-size: 10px;
  text-align: left;
  line-height: 12px;
}

tbody tr:first-child td {
  padding-top: 20px;
}

tbody tr:nth-child(even) td {
  background-color: #F0EFEF;
}

</style>

<script>
export default {
  data () {
    return {
      activeContentId: 2,
      isHasInfo: false
    }
  },
  methods: {
    changeContent (id) {
      if (id === this.activeContentId) {
        return
      }
      this.activeContentId = id
    }
  },
  created () {
    if (!localStorage.userToken) {
      this.$router.replace({ name: 'personal' })
    }
  }
}
</script>
